import { motion } from 'framer-motion';

const ValuesSection = () => {
  const values = [
    {
      icon: 'ri-shield-check-line',
      title: 'Reliability',
      description: 'We turn up on time, every time. Our reputation is built on dependable service and keeping our promises to customers across Wharfedale.',
    },
    {
      icon: 'ri-hammer-line',
      title: 'Quality Workmanship',
      description: 'Every job is completed to the highest standard using quality materials and proven techniques. We take pride in work that lasts.',
    },
    {
      icon: 'ri-heart-line',
      title: 'Customer Care',
      description: 'Your satisfaction is our priority. We listen to your needs, explain our work clearly, and leave your property clean and tidy.',
    },
  ];

  return (
    <section className="py-24 bg-[#F7F9FB]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-[#1A2F4A]">Our Values</h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {values.map((value, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.15 }}
              className="text-center"
            >
              <div className="w-20 h-20 flex items-center justify-center mx-auto mb-6">
                <i className={`${value.icon} text-6xl text-[#1A2F4A]`}></i>
              </div>
              <h3 className="text-2xl font-bold text-[#1A2F4A] mb-4">{value.title}</h3>
              <p className="text-gray-600 leading-relaxed">{value.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValuesSection;